module.exports = __webpack_public_path__ + "img/no-picture.d7cbf68d.png";